import { KpiVariable } from 'types/GlobalKpiVariable'

export function getPutOrder(
  variables: KpiVariable[],
  order: KpiVariable[],
  parentId?: string
) {
  const levelZero = parentId ? variables.filter((v) => v.level === 0) : order
  const levelOne = variables.filter((v) => v.level === 1)
  const levelTwo = variables.filter((v) => v.level === 2)

  const initialSort: KpiVariable[] = []

  levelZero.forEach((v0) => {
    initialSort.push(v0)

    const levelOneChildren =
      v0.id === parentId
        ? order
        : levelOne.filter((v1) => v1.parent_kpi_variable_id === v0.id)

    levelOneChildren.forEach((v1) => {
      initialSort.push(v1)

      const levelTwoChildren =
        v1.id === parentId
          ? order
          : levelTwo.filter((v2) => v2.parent_kpi_variable_id === v1.id)

      initialSort.push(...levelTwoChildren)
    })
  })

  return initialSort.map((v) => v.id)
}
